module.exports = __webpack_public_path__ + "static/img/SHOLA.437a593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SHOLA.png
// module id = nrln
// module chunks = 0